import * as React from 'react';
import { useDropzone, FileWithPath } from 'react-dropzone';
import { formatBytes } from '../../Hooks/bytesToMB';

export interface IAppProps {
}

export function Previews(props: IAppProps) {
    const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
        accept: 'image/jpeg,image/png,',
        // maxSize: 100000000,
    });
    const files = acceptedFiles.map((file: FileWithPath) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));


    return (
        <div className="xs:w-full xs:hidden lg:block xs:mb-7 lg:mb-0 lg:w-44 xl:w-56 xs:ml-0 lg:ml-16 xl:ml-24 text-left xs:order-1 lg:order-2">
            <h4 className="text-cusBlack font-bold dark:font-medium dark:text-white text-lg">Preview</h4>
            <div
                {...getRootProps({ className: 'preview_upload_box rounded-xl w-full xs:h-36 sm:h-44 lg:h-64 mt-3 flex justify-center items-center' })}>
                {files.length !== 0
                    ? <p className="text-sm w-8/12 text-cusBlack dark:text-cusBlueWhite">Your file: {files} </p>
                    : <p className="text-sm w-8/12 text-cusBlack dark:text-cusBlueWhite">Upload file to preview your brand new NFT</p>
                }
            </div>

        </div>
    );
}
